import { read, utils, write, writeFileXLSX } from "xlsx"
import { accessGlobalMiscState } from "../stores/misc"
import { accessGlobalUserState } from "../stores/user"
import { clubMeta } from "./constants"
import ExcelJS from "exceljs";
import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun, WidthType, AlignmentType, HeadingLevel, BorderStyle, VerticalAlign } from "docx";
import { saveAs } from "file-saver";

const returnOrError = (resData, arr = false) => {
  if (resData.error) {
    return arr ? [] : {}
  } else {
    return resData
  }
}

const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)

const isVideoPaused = video => !!(video.currentTime > 0 && video.paused && !video.ended && video.readyState > 2)

const getFileSize = (url) => {
  fetch(url)
    .then(res => {
      if (!res.ok) {
        console.log('sdaasd')
        return res.text().then(text => { throw new Error('assda') })
      }
      else {
        return res.json();
      }
    })
    .catch(err => {
      console.log('caught it!', err);
    });
}

const isCurrentLink = (location, link) => {
  return location.pathname === link
}

const hasTopicFailedDeadline = (topic) => {
  for (let lesson of topic?.lessons) {
    if ('lessonsProgress' in lesson) {
      if (!lesson.lessonsProgress.isPassedOnTime) {
        return true
      }
    }
  }
  return false
}

const quizQuestionClass = (question, meta) => {
  let isCorrect = true
  const foundQuestion = meta.history.find(q => q.id === question.id)
  console.log(question, foundQuestion)
  if (!!foundQuestion) {
    for (let answerId of question?.userAnswerIds) {
      const foundAnswer = foundQuestion.answers.find(a => a.id === answerId)
      if (!!foundAnswer && !foundAnswer.isCorrect) {
        isCorrect = false
      }
    }
    if (question?.userAnswerIds?.length !== foundQuestion.answers.filter(a => a.isCorrect).length) {
      isCorrect = false
    }
  }
  return {
    className: isCorrect ? 'bg-question-correct' : 'bg-question-incorrect',
    isCorrect

  }
}

const onInputChangeNative = (localState, key) => (e) => {
  localState.merge({
    [key]: e.target.value
  })
}

const updateLocalStateRaw = (localState, key) => (value) => {
  localState[key]?.set(value);
}

const updateMiscState = key => value => {
  accessGlobalMiscState().set(key, value)
}

const sortById = (a, b) => a.id - b.id

const isAnswerCorrect = (ansId, question, meta) => {
  let isCorrect = false
  const foundQuestion = meta.history.find(q => q.id === question.id)
  if (!!foundQuestion) {
    const foundAnswer = foundQuestion.answers.find(a => a.id === ansId)
    if (!!foundAnswer) {
      isCorrect = foundAnswer.isCorrect
    }
  }
  return isCorrect
}

const getRandomFromArray = (items) => items[Math.floor(Math.random() * items.length)]

const totalQuizStats = (questions, meta) => {
  const totalCorrectAnswers = meta.history.reduce((qAcc, qCurr) => qAcc + qCurr.answers.filter(ans => ans.isCorrect).length, 0)
  const totalUserCorrectAnswers = questions.reduce((qAcc, qCurr) => {
    const foundQuestion = meta.history.find(q => q.id === qCurr.id)
    console.log(qCurr.userAnswerIds, foundQuestion.answers)
    const correct = qCurr.userAnswerIds.filter(ans => !!foundQuestion.answers.find(a => a.isCorrect && a.id === ans))
    return qAcc + correct.length
  }, 0)
  return {
    totalCorrectAnswers,
    totalUserCorrectAnswers
  }
}

const classesAverageWatchedTime = (lessons) => {
  if (!!lessons.length) {
    return lessons.reduce((acc, curr) => acc + (curr.lessonsProgress?.videoWatched || 0), 0) / lessons.length
  }
  return 0
}

const getTiming = (timingRaw, width, duration) => {
  const secondsRaw = Math.floor((timingRaw / width) * duration)
  let minutes = Math.floor(secondsRaw / 60)
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  let seconds = secondsRaw % 60
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${minutes}:${seconds}`
}

const getTableClassname = (i, j) => {
  if (i % 2 === 0) {
    let str = 'bg-table-row-gray '
    if (j === 0) {
      str += 'rounded-bl-[10px] rounded-tl-[10px]'
    } else if (j === 5) {
      str += 'rounded-br-[10px] rounded-tr-[10px]'
    }
    return str
  }
  return ''
}

const getHHMMFromDateString = (str) => {
  const date = new Date(str)
  return `${date.getHours()}:${`${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`}`
}

const stringTimeToSeconds = (timing) => {
  const splitted = timing.split(':')
  if (splitted.length > 1) {
    return (60 * parseInt(splitted[0])) + parseInt(splitted[1])
  }
  return 0
}

const showSnackbar = (text, severity = 'error') => {
  accessGlobalMiscState().set('snackbarContent', text)
  accessGlobalMiscState().set('snackbarSeverity', severity)
  accessGlobalMiscState().set('snackbarOpen', true)
}

const socialTranscriptItemsReduce = (acc, curr) => acc + (curr.status === - 1 ? 0 : curr.social_subcategory.points)

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const getDateOnly = date => new Intl.DateTimeFormat('en-GB').format(new Date(date || new Date())).replace(/\//g, '.');

const getPsychologistAppointmentMeta = (event) => {
  const client = event.clientSelf;
  const meta = {
    bgColor: '#F0F3FA',
    text: '',
    textColor: '',
    textBg: ''
  }
  if (!client?.id) {
    return meta
  }

  if (client.status === -1) {
    meta.bgColor = '#F12D2D33'
    meta.text = 'Отменено'
    meta.textColor = '#F12D2D'
    meta.textBg = '#F12D2D33'
  } else if (client.status === 2) {
    meta.bgColor = '#8F30BC33'
    meta.text = 'Предложено'
    meta.textColor = '#8F30BC'
    meta.textBg = '#8F30BC33'
  } else if (client.status === 1 && event.day < new Date()) {
    meta.bgColor = '#3BBC3033'
    meta.text = 'Прошло'
    meta.textColor = '#0B8C00'
    meta.textBg = '#3BBC3033'
  } else {
    meta.bgColor = '#0068FF33'
  }

  return meta;
}

const userHasRole = (role) => {
  const userState = accessGlobalUserState()
  const user = userState.get()
  const uniqUser = user.uniqUser || {}
  return uniqUser.roles?.find(r => r.name === role)
}

const userHasRoles = (roles) => {
  const userState = accessGlobalUserState()
  const user = userState.get()
  const uniqUser = user.uniqUser || {}
  return roles.every(searchRole => uniqUser.roles?.find(r => r.name === searchRole))
}

const userHasUnixRoles = (roles) => {
  const userState = accessGlobalUserState()
  const user = userState.get()
  const unixRoles = user.unixRoles || []
  if (!roles?.length) {
    return false
  }
  return roles.every(searchRole => unixRoles.find(r => r === searchRole))
}

const getRolesSegmented = (roles) => {
  const final = [];
  for (const r of roles.filter(r => r.category_name)) {
    const found = final.find(sr => sr.category_name === r.category_name)
    if (found) {
      found.list.push(r)
    } else {
      final.push({
        category_name: r.category_name,
        list: [r]
      })
    }
  }
  return final;
}

const getSegmentedRolesOnly = (segmentedRoles) => segmentedRoles.reduce((acc, curr) => [...acc, ...curr.list], [])

const getClubMeta = (clubTypeName) => clubMeta.find(m => m.clubTypeName === clubTypeName) || clubMeta[0]

const timeStringForFileName = () => new Date().toLocaleTimeString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replaceAll('.', '_').replace(', ', '_').replace(':', '_')

const exportToExcel = (prefix, data, columns) => () => {
  const finalData = []
  for (let itemIndex in data) {
    const item = data[itemIndex]
    const object = {}
    for (let metaItem of columns) {
      if (metaItem.type === 'order') {
        object[metaItem.label] = parseInt(itemIndex) + 1
      } else {
        object[metaItem.label] = metaItem.rawData(item)
      }
    }
    finalData.push(object)
  }
  const wb = utils.book_new()
  const ws = utils.json_to_sheet(finalData)
  utils.book_append_sheet(wb, ws, "students")
  writeFileXLSX(wb, `${prefix}_${timeStringForFileName()}.xlsx`)
}

const columnKeys = [
  "ID *",
  "Student",
  "Attended",
  "Late",
  "Absent",
  "Grade",
  "Comments",
  "Statistic"
];

const exportToExcelTemplate = (prefix, data, columns, course, lesson) => async () => {
  const finalData = [];
  const columnKeys = columns.map(c => c.label);

  for (let itemIndex in data) {
      const item = data[itemIndex];
      const rowObj = {};
      for (let col of columns) {
          if (col.type === "order") {
              rowObj[col.label] = Number(itemIndex) + 1;
          } else {
              rowObj[col.label] = col.rawData(item);
          }
      }
      finalData.push(rowObj);
  }

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Report", {
      views: [{ state: "frozen", ySplit: 3 }]
  });

  // Название курса
  const title = `${course.name} ${getDateOnly(lesson.start_time)}`;
  sheet.mergeCells(1, 1, 1, 7);
  const titleCell = sheet.getCell(1, 1);
  titleCell.value = title;
  titleCell.font = { size: 16, bold: true };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };

  // Просто текстовое логическое значение вместо "чекбокса"
  const h1 = sheet.getCell("H1");
  h1.value = "FALSE"; // начальное значение
  h1.font = { size: 12 };
  h1.alignment = { horizontal: 'center', vertical: 'middle' };

  sheet.addRow([]);

  const headerRow = sheet.addRow(columnKeys);
  headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
      };
  });

  finalData.forEach(rowObj => {
      const rowValues = columnKeys.map(k => rowObj[k]);
      const row = sheet.addRow(rowValues);
      row.eachCell(cell => {
          cell.alignment = { vertical: "middle" };
          cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" }
          };
      });
  });

  sheet.columns.forEach(col => {
      let maxLength = 12;
      col.eachCell(cell => {
          const value = cell.value ? cell.value.toString() : "";
          if (value.length > maxLength) maxLength = value.length;
      });
      col.width = maxLength + 2;
  });

  // Инструкции справа
  const instructionStartCol = columnKeys.length + 1;
  const instruction = [
      "Что запрещается:",
      "Изменять названия колонок, помеченных *",
      "Изменять вручную ID студентов",
      "Добавлять строки перед таблицей (заголовки должны быть на строке 3)",
      "",
      "Что можно:",
      "Удалять или скрывать колонки без *",
      "Скрывать строки",
      "Добавлять вспомогательные колонки",
      "Сортировать и фильтровать строки",
      "Изменять цвет ячеек",
      "Добавлять свои формулы",
      "Добавлять строки в таблицу, но только с пустым ID"
  ];

  instruction.forEach((text, i) => {
      const cell = sheet.getCell(i + 1, instructionStartCol);
      cell.value = text;
      cell.font = { size: i === 0 ? 14 : 12, bold: i === 0 };
      cell.alignment = { vertical: "middle", wrapText: true };
      cell.border = {
          top: i === 0 ? { style: 'thin' } : undefined,
          bottom: i === instruction.length - 1 ? { style: 'thin' } : undefined,
          left: { style: 'thin' },
          right: { style: 'thin' }
      };
  });

  sheet.getColumn(instructionStartCol).width = 45;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${prefix}_${timeStringForFileName()}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};


// const exportToExcelTemplate = (prefix, data, columns, course, lesson) => async () => {
//     const finalData = [];
//     const columnKeys = columns.map(c => c.label);

//     for (let itemIndex in data) {
//         const item = data[itemIndex];
//         const rowObj = {};
//         for (let col of columns) {
//             if (col.type === "order") {
//                 rowObj[col.label] = Number(itemIndex) + 1;
//             } else {
//                 rowObj[col.label] = col.rawData(item);
//             }
//         }
//         finalData.push(rowObj);
//     }

//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Report", {
//         views: [{ state: "frozen", ySplit: 3 }]
//     });

//     // Название курса - объединяем только до колонки G (7)
//     const title = `${course.name} ${getDateOnly(lesson.start_time)}`;
//     sheet.mergeCells(1, 1, 1, 7); // Объединяем A1:G1
//     const titleCell = sheet.getCell(1, 1);
//     titleCell.value = title;
//     titleCell.font = { size: 16, bold: true };

//     // Создаем чекбокс в H1
//     const h1 = sheet.getCell("H1");
//     h1.value = false; // начальное значение
//     h1.dataValidation = {
//         type: 'list',
//         allowBlank: false,
//         formulae: ['"TRUE,FALSE"'],
//         showInputMessage: true,
//         promptTitle: 'Checkbox',
//         prompt: 'Select TRUE or FALSE'
//     };
//     h1.font = { size: 12 };
//     h1.alignment = { horizontal: 'center', vertical: 'middle' };

//     sheet.getRow(1).eachCell((cell, colNumber) => {
//         // Пропускаем H1 (колонка 8)
//         if (colNumber !== 8 && colNumber <= columnKeys.length) {
//             cell.dataValidation = null;
//         }
//     });

//     sheet.addRow([]);

//     const headerRow = sheet.addRow(columnKeys);
//     headerRow.eachCell(cell => {
//         cell.font = { bold: true };
//         cell.alignment = { vertical: "middle" };
//         cell.border = {
//             top: { style: "thin" },
//             left: { style: "thin" },
//             bottom: { style: "thin" },
//             right: { style: "thin" }
//         };
//     });

//     finalData.forEach(rowObj => {
//         const rowValues = columnKeys.map(k => rowObj[k]);
//         const row = sheet.addRow(rowValues);
//         row.eachCell(cell => {
//             cell.alignment = { vertical: "middle" };
//             cell.border = {
//                 top: { style: "thin" },
//                 left: { style: "thin" },
//                 bottom: { style: "thin" },
//                 right: { style: "thin" }
//             };
//         });
//     });

//     sheet.columns.forEach(col => {
//         let maxLength = 12;
//         col.eachCell(cell => {
//             const value = cell.value ? cell.value.toString() : "";
//             if (value.length > maxLength) maxLength = value.length;
//         });
//         col.width = maxLength + 2;
//     });

//     const instructionStartCol = columnKeys.length + 1;
//     const instruction = [
//         "Что запрещается:",
//         "Изменять названия колонок, помеченных *",
//         "Изменять вручную ID студентов",
//         "Добавлять строки перед таблицей (заголовки должны быть на строке 3)",
//         "",
//         "Что можно:",
//         "Удалять или скрывать колонки без *",
//         "Скрывать строки",
//         "Добавлять вспомогательные колонки",
//         "Сортировать и фильтровать строки",
//         "Изменять цвет ячеек",
//         "Добавлять свои формулы",
//         "Добавлять строки в таблицу, но только с пустым ID"
//     ];

//     let instructionRow = 1;
//     instruction.forEach(text => {
//         const cell = sheet.getCell(instructionRow, instructionStartCol);
//         cell.value = text;

//         if (instructionRow === 1) {
//             cell.font = { bold: true, size: 14 };
//         } else {
//             cell.font = { size: 12 };
//         }

//         cell.alignment = { vertical: "middle" };

//         instructionRow++;
//     });

//     const instructionStartRow = 1;
//     const instructionEndRow = instructionStartRow + instruction.length - 1;

//     for (let r = instructionStartRow; r <= instructionEndRow; r++) {
//         const cell = sheet.getCell(r, instructionStartCol);

//         cell.border = {
//             top: r === instructionStartRow ? { style: "thin" } : undefined,
//             bottom: r === instructionEndRow ? { style: "thin" } : undefined,
//             left: { style: "thin" },
//             right: { style: "thin" }
//         };
//     }

//     sheet.getColumn(instructionStartCol).width = 45;

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//     });

//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${prefix}_${timeStringForFileName()}.xlsx`;
//     a.click();
//     URL.revokeObjectURL(url);
// };

// const exportToExcelTemplate = (prefix, data, columns, course, lesson) => async () => {
//   // Подготовка данных
//   const finalData = [];
//   const columnKeys = columns.map(c => c.label);

//   for (let itemIndex in data) {
//     const item = data[itemIndex];
//     const object = {};

//     for (let metaItem of columns) {
//       if (metaItem.type === 'order') {
//         object[metaItem.label] = parseInt(itemIndex) + 1;
//       } else {
//         object[metaItem.label] = metaItem.rawData(item);
//       }
//     }

//     finalData.push(object);
//   }

//   // Загружаем шаблон
//   const response = await fetch('/export_template.xlsx');
//   const arrayBuffer = await response.arrayBuffer();
//   const workbook = read(arrayBuffer, { type: 'array' });

//   const sheetName = workbook.SheetNames[0];
//   const worksheet = workbook.Sheets[sheetName];

//   // Заголовок урока
//   const newLessonTitle = `${course.name} ${getDateOnly(lesson.start_time)}`;
//   worksheet["A1"] = {
//     t: "s",
//     v: newLessonTitle,
//     w: newLessonTitle,
//     s: { font: { bold: true, sz: 14 } }
//   };

//   const startRow = 4;

//   // === HEADER ROW ===
//   columnKeys.forEach((label, colIndex) => {
//     const cellAddress = utils.encode_cell({ r: startRow - 1, c: colIndex });

//     worksheet[cellAddress] = {
//       t: "s",
//       v: label,
//       s: {
//         font: { bold: true },
//         alignment: { horizontal: "center", vertical: "center" },
//         border: {
//           top: { style: "thin", color: { rgb: "000000" } },
//           left: { style: "thin", color: { rgb: "000000" } },
//           bottom: { style: "thin", color: { rgb: "000000" } },
//           right: { style: "thin", color: { rgb: "000000" } }
//         }
//       }
//     };
//   });

//   // === DATA ROWS ===
//   finalData.forEach((rowObj, rowIndex) => {
//     columnKeys.forEach((key, colIndex) => {
//       const cellValue = rowObj[key] ?? "";
//       const cellAddress = utils.encode_cell({
//         r: startRow + rowIndex,
//         c: colIndex,
//       });

//       worksheet[cellAddress] = {
//         t: typeof cellValue === "number" ? "n" : "s",
//         v: cellValue,
//         s: {
//           alignment: { horizontal: "center", vertical: "center" },
//           border: {
//             top: { style: "thin", color: { rgb: "000000" } },
//             left: { style: "thin", color: { rgb: "000000" } },
//             bottom: { style: "thin", color: { rgb: "000000" } },
//             right: { style: "thin", color: { rgb: "000000" } }
//           }
//         }
//       };
//     });
//   });

//   // === AUTO WIDTH ===
//   worksheet['!cols'] = columnKeys.map((_, colIndex) => {
//     let maxWidth = columnKeys[colIndex].length;

//     finalData.forEach(row => {
//       const value = row[columnKeys[colIndex]];
//       if (value != null) {
//         const len = String(value).length;
//         if (len > maxWidth) maxWidth = len;
//       }
//     });

//     return { wch: maxWidth + 2 };
//   });

//   // Обновляем диапазон
//   const lastRow = startRow + finalData.length - 1;
//   worksheet["!ref"] = `A1:${utils.encode_cell({ r: lastRow, c: columnKeys.length - 1 })}`;

//   // Скачивание файла
//   const wbout = write(workbook, { bookType: "xlsx", type: "binary" });
//   const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
//   const url = URL.createObjectURL(blob);

//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `${prefix}_${timeStringForFileName()}.xlsx`;
//   a.click();
//   URL.revokeObjectURL(url);
// };


function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

const getAverageRatingForLesson = lesson => {
  if (!lesson.ratings.length) {
    return '-'
  } else {
    return lesson.ratings.reduce((acc, curr) => acc + (curr.json_ratings["Подготовленность преподавателя"] || 0), 0) / lesson.ratings.length
  }
}

const getStudentAttendanceAndGrade = (lesson, student) => {
  const data = {
    attendance: false,
    grade: '-'
  }
  const found = lesson.attendances.find(a => a.main_user_id === student.id)
  data.attendance = Boolean(found?.did_attend)
  if (found) {
    data.grade = found.grade
  }
  return data
}

/**
 * Exports social transcript to DOCX format
 * @param {StudentForSocialTranscript} student - Student object with social transcript data
 * @param {Array} socialTranscriptItems - Array of social transcript items
 * @param {number} score - Total score for social transcript
 * @returns {Function} Async function that generates and downloads the DOCX file
 */
const exportSocialTranscriptToDocx = (student, socialTranscriptItems, score) => async () => {
  const studentData = student?.json_saved_data || {};
  const firstName = studentData.firstname || '';
  const lastName = studentData.lastname || '';
  const studentId = studentData.externalId || '';
  const yearOfStudy = studentData.yearOfStudy || '';
  // Try multiple possible field names for school/faculty
  const department = studentData.faculty || studentData.department || studentData.organization || '';
  // Try multiple possible field names for specialty
  const subOrganization = studentData.speciality || studentData.specialty || studentData.subOrganization || '';
  
  // Calculate total score
  const totalScore = score || socialTranscriptItems.reduce((sum, item) => {
    return sum + (item.social_subcategory?.points || 0);
  }, 0);

  // Create document
  const doc = new Document({
    sections: [{
      properties: {
        page: {
          margin: {
            top: 1440,
            right: 1440,
            bottom: 1440,
            left: 1440,
          }
        }
      },
      children: [
        // Student Information Table
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.NONE, size: 0 },
            bottom: { style: BorderStyle.NONE, size: 0 },
            left: { style: BorderStyle.NONE, size: 0 },
            right: { style: BorderStyle.NONE, size: 0 },
            insideHorizontal: { style: BorderStyle.NONE, size: 0 },
            insideVertical: { style: BorderStyle.NONE, size: 0 }
          },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Student's full name ", bold: true }),
                        new TextRun({ text: `${firstName} ${lastName}` })
                      ]
                    })
                  ],
                  width: { size: 50, type: WidthType.PERCENTAGE },
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Student's ID ", bold: true }),
                        new TextRun({ text: studentId })
                      ]
                    })
                  ],
                  width: { size: 50, type: WidthType.PERCENTAGE },
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Year of admission ", bold: true }),
                        new TextRun({ text: "" })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Study year ", bold: true }),
                        new TextRun({ text: String(yearOfStudy || '') })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Education type ", bold: true }),
                        new TextRun({ text: "" })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Study language ", bold: true }),
                        new TextRun({ text: "" })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "School ", bold: true }),
                        new TextRun({ text: department || '' })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Specialty/Educational program ", bold: true }),
                        new TextRun({ text: subOrganization || '' })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({ text: "Academic level ", bold: true }),
                        new TextRun({ text: "Undergraduate" })
                      ]
                    })
                  ],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                }),
                new TableCell({
                  children: [new Paragraph({ text: "" })],
                  borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } }
                })
              ]
            })
          ]
        }),
        
        // Positions held in student life section
        new Paragraph({
          children: [
            new TextRun({ text: "Positions held in student life", bold: true })
          ],
          spacing: { before: 400, after: 200 }
        }),
        
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE, size: 1 },
            bottom: { style: BorderStyle.SINGLE, size: 1 },
            left: { style: BorderStyle.SINGLE, size: 1 },
            right: { style: BorderStyle.SINGLE, size: 1 },
            insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
            insideVertical: { style: BorderStyle.SINGLE, size: 1 }
          },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ text: "№", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({
                  children: [new Paragraph({ text: "Positions held in student life", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 60, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({
                  children: [new Paragraph({ text: "Period", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 30, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({ children: [new Paragraph({ text: "1" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] })
              ]
            })
          ]
        }),
        
        new Paragraph({ text: "", spacing: { after: 400 } }),
        
        // Track record section
        new Paragraph({
          children: [
            new TextRun({ text: "Track record", bold: true })
          ],
          spacing: { before: 400, after: 200 }
        }),
        
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE, size: 1 },
            bottom: { style: BorderStyle.SINGLE, size: 1 },
            left: { style: BorderStyle.SINGLE, size: 1 },
            right: { style: BorderStyle.SINGLE, size: 1 },
            insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
            insideVertical: { style: BorderStyle.SINGLE, size: 1 }
          },
          rows: [
            new TableRow({
              children: [
                new TableCell({ 
                  children: [new Paragraph({ text: "№", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 5, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Name", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 20, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Type of direction", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 15, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Level", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Role", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Contribution", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 15, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Duration", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Status", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 10, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({ 
                  children: [new Paragraph({ text: "Points", bold: true, alignment: AlignmentType.CENTER })],
                  width: { size: 5, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER
                })
              ]
            }),
            ...socialTranscriptItems.map((item, index) => {
              const categoryName = item.social_subcategory?.social_category?.name || '';
              const subcategoryName = item.social_subcategory?.name || '';
              const points = item.social_subcategory?.points || 0;
              const date = getDateOnly(item.createdAt) || '';
              
              return new TableRow({
                children: [
                  new TableCell({ children: [new Paragraph({ text: String(index + 1), alignment: AlignmentType.CENTER })] }),
                  new TableCell({ children: [new Paragraph({ text: subcategoryName })] }),
                  new TableCell({ children: [new Paragraph({ text: categoryName })] }),
                  new TableCell({ children: [new Paragraph({ text: "" })] }),
                  new TableCell({ children: [new Paragraph({ text: "" })] }),
                  new TableCell({ children: [new Paragraph({ text: "" })] }),
                  new TableCell({ children: [new Paragraph({ text: date })] }),
                  new TableCell({ children: [new Paragraph({ text: "" })] }),
                  new TableCell({ children: [new Paragraph({ text: String(points), alignment: AlignmentType.CENTER })] })
                ]
              });
            }),
            ...(socialTranscriptItems.length === 0 ? [new TableRow({
              children: [
                new TableCell({ children: [new Paragraph({ text: "1" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] }),
                new TableCell({ children: [new Paragraph({ text: "" })] })
              ]
            })] : [])
          ]
        }),
        
        new Paragraph({ text: "", spacing: { after: 400 } }),
        
        // Total score and Level with borders
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE, size: 1 },
            bottom: { style: BorderStyle.SINGLE, size: 1 },
            left: { style: BorderStyle.SINGLE, size: 1 },
            right: { style: BorderStyle.SINGLE, size: 1 }
          },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ text: `Total score: ${totalScore}` })],
                  borders: {
                    bottom: { style: BorderStyle.NONE, size: 0 }
                  }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ text: "Level:" })],
                  borders: {
                    top: { style: BorderStyle.NONE, size: 0 }
                  }
                })
              ]
            })
          ]
        }),
        
        new Paragraph({ text: "", spacing: { after: 600 } }),
        
        // Signature
        new Paragraph({
          children: [
            new TextRun({ text: "Acting Vice-Rector for social and educational issues Sabit Sultanov", bold: true })
          ]
        })
      ]
    }]
  });

  // Generate and download
  try {
    const blob = await Packer.toBlob(doc);
    const fileName = `social_transcript_${firstName}_${lastName}_${new Date().toISOString().split('T')[0]}.docx`;
    saveAs(blob, fileName);
    showSnackbar('Социальный транскрипт успешно выгружен', 'success');
  } catch (error) {
    console.error('Error generating document:', error);
    showSnackbar('Ошибка при выгрузке социального транскрипта', 'error');
  }
}
export {
  returnOrError,
  isVideoPlaying,
  isVideoPaused,
  getTiming,
  stringTimeToSeconds,
  hasTopicFailedDeadline,
  classesAverageWatchedTime,
  quizQuestionClass,
  totalQuizStats,
  isCurrentLink,
  isAnswerCorrect,
  getRandomFromArray,
  getFileSize,
  getTableClassname,
  getHHMMFromDateString,
  showSnackbar,
  onInputChangeNative,
  sleep,
  getDateOnly,
  updateLocalStateRaw,
  updateMiscState,
  socialTranscriptItemsReduce,
  getPsychologistAppointmentMeta,
  sortById,
  userHasRole,
  userHasRoles,
  userHasUnixRoles,
  getRolesSegmented,
  getSegmentedRolesOnly,
  getClubMeta,
  exportToExcel,
  exportToExcelTemplate,
  getAverageRatingForLesson,
  getStudentAttendanceAndGrade,
  exportSocialTranscriptToDocx
}